import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Log from "./pages/Log";
import Lift from "./pages/Lift";
import Movement from "./pages/Movement";
import TopBar from "./components/TopBar";
import BottomBar from "./components/BottomBar";
import "./styles/pages.css";
import "./styles/navigation.css";

function App() {
  const [lifts, setLifts] = useState([]);
  const [showForm, setShowForm] = useState(false); // Move showForm state to App.js

  return (
    <Router>
      <div className="app-container">
        <TopBar />
        <div className="content">
          <Routes>
            <Route 
              path="/" 
              element={<Log lifts={lifts} setLifts={setLifts} showForm={showForm} setShowForm={setShowForm} />} 
            />
            <Route path="/lift/:liftId" element={<Lift lifts={lifts} />} />
            <Route path="/lift/:liftId/movement" element={<Movement />} />
          </Routes>
        </div>
        <BottomBar setShowForm={setShowForm} /> {/* Pass setShowForm to BottomBar */}
      </div>
    </Router>
  );
}

export default App;
